import { displayTokenToLabelFilter } from '@ipfabric/utils';
import { getReservedLabelValueError } from '@ipfabric/utils/labels';
import { z } from 'zod';

const selectedAssignmentTargetSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('device'),
    sn: z.string().min(1),
    hostname: z.string().nullable(),
  }),
  z.object({
    type: z.literal('intL2'),
    sn: z.string().min(1),
    interfaceName: z.string().min(1),
    hostname: z.string().nullable(),
  }),
]);

export const assignLabelsFormSchema = z.object({
  targets: z
    .array(selectedAssignmentTargetSchema)
    .min(1, 'Select at least one target.'),
  labels: z
    .array(z.string().min(1))
    .min(1, 'Select at least one label.')
    .superRefine((tokens, ctx) => {
      // Picked tokens come from the catalog; guard entries that predate the
      // reserved value contract (ipf_region).
      const message = tokens
        .map((token) => {
          const { name, value } = displayTokenToLabelFilter(token);
          return getReservedLabelValueError(name, value ?? '');
        })
        .find((error) => error !== null);
      if (message) {
        ctx.addIssue({ code: 'custom', message });
      }
    }),
  inherit: z.boolean(),
  reflectToRules: z.boolean(),
});

export type AssignLabelsFormSchemaValues = z.infer<
  typeof assignLabelsFormSchema
>;

export const assignLabelsFormDefaultValues: AssignLabelsFormSchemaValues = {
  targets: [],
  labels: [],
  inherit: false,
  reflectToRules: false,
};
